import 'arrayq';
import { createSelector } from 'reselect';

import { bookmarksResource } from '../bookmarks/resource';
import { notesResource } from '../notes/resource';

const recentCategoryIds = createSelector(
    notesResource.selectors.items,
    bookmarksResource.selectors.items,
    (notes, bookmarks) => {
        return [].concat(
            notes.qSelect((x) => ({ id: x.categoryId, lastEdited: new Date(x.lastEdited).getTime() })),
            bookmarks.qSelect((x) => ({ id: x.categoryId, lastEdited: new Date(x.lastEdited).getTime() })),
        )
            .sort((a, b) => b.lastEdited - a.lastEdited).qDistinct((x) => x.id);
    },
);

export default {
    mostUsed: recentCategoryIds,
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/categorySelectPopup/reselectors.tsx